import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Category } from '../categories/Category';
import { getUserInfo } from '../../../selectors/gatesSelector';
import { ANALYTICS_SUITE_TAB_IDS } from '../../types/navigation';
import { useSuiteTemplates } from '../../../utils/useSuiteTemplates';
import { ANALYTICS_SUITE_CATEGORY_IDS } from '../../constants/navigation';
import { useReportTemplateRecommendations } from 'reporting-discover-components/utils/recommendations/reportRecommendationUtils';
import { getRecentlyViewedSubAppKeysForHomePage } from '../../../utils/recentlyViewedTemplatesUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const NUM_RECOMMENDATIONS = 4;
export const RecommendedTemplates = () => {
  const suiteId = ANALYTICS_SUITE_TAB_IDS.DISCOVER;
  const suiteTemplates = useSuiteTemplates(suiteId);
  const eligibleTemplates = useMemo(() => {
    const recentlyViewedSubApps = getRecentlyViewedSubAppKeysForHomePage(suiteId);
    return suiteTemplates.filter(template => !recentlyViewedSubApps.includes(template.getIn(['suiteNavData', 'navItemId'])));
  }, [suiteId, suiteTemplates]);
  const userInfo = useSelector(getUserInfo);
  const results = useReportTemplateRecommendations(eligibleTemplates, userInfo);
  if (results.isEmpty()) {
    return null;
  }
  const recommendations = results.take(NUM_RECOMMENDATIONS).map(template => {
    return template;
  }).toArray();
  return recommendations.length > 0 && /*#__PURE__*/_jsx(Category, {
    id: ANALYTICS_SUITE_CATEGORY_IDS.RECOMMENDED,
    labelKey: 'smartLibrary.analyticsSuite.categories.recommendations',
    tooltipKey: 'smartLibrary.analyticsSuite.categories.tooltips.recommendations',
    templates: recommendations
  });
};